export default {
  // 音频详情接口
  getAudioDetailById: '/member/anonymous/amc/getAudionContentById',
}